



























import { Component, Prop, Vue } from "vue-property-decorator";
import { Product as ProductType, ProductVariant as VariantType } from "shopify-buy";

@Component
export default class Product extends Vue {
  @Prop({ required: true }) addToCheckout!: (variantId: string, quantity: number) => void;
  @Prop({ required: true }) removeFromCheckout!: (variantId: string) => void;
  @Prop({ required: true }) inCheckout!: boolean;
  @Prop({ required: true }) isPurchased!: boolean;
  @Prop({ required: true }) isLoading!: boolean;
  @Prop({ required: true }) product!: typeof ProductType;
  @Prop({ required: true }) variant!: typeof VariantType;

  handleAddToCheckout() {
    this.addToCheckout(this.variant.id.toString(), 1);
  }
  handleRemoveFromCheckout() {
    this.removeFromCheckout(this.variant.id.toString());
  }
}
